import { withErrorBoundary } from '@/components/ui/error-boundary';
import {
  LazyDashboard,
  LazyOrganizations,
  LazyContacts,
  LazyOpportunities,
  LazyAnalytics,
  LazyLandExpand,
  LazyDocuments,
  LazyDataImport,
  LazyDataExport,
  LazyProjects,
  LazyUserManagement,
  LazyInvoices,
  LazyHubSpotIntegration,
  withSuspense,
} from './lazyRoutes';
import Gifts from '@/pages/Gifts';
import Docs from '@/pages/Docs';
import SimplifiedAutomation from '@/pages/SimplifiedAutomation';
import CommunicationHub from '@/pages/CommunicationHub';
import FinancialDashboard from '@/pages/FinancialDashboard';
import SecurityDashboard from '@/pages/SecurityDashboard';
import IntegrationSettings from '@/pages/IntegrationSettings';

// Wrap lazy route components with error boundaries and suspense
export const SafeDashboard = withErrorBoundary(withSuspense(LazyDashboard));
export const SafeOrganizations = withErrorBoundary(withSuspense(LazyOrganizations));
export const SafeContacts = withErrorBoundary(withSuspense(LazyContacts));
export const SafeOpportunities = withErrorBoundary(withSuspense(LazyOpportunities));
export const SafeAnalytics = withErrorBoundary(withSuspense(LazyAnalytics));
export const SafeLandExpand = withErrorBoundary(withSuspense(LazyLandExpand));
export const SafeDocuments = withErrorBoundary(withSuspense(LazyDocuments));
export const SafeGifts = withErrorBoundary(Gifts); // Keep immediate for now
export const SafeDataImport = withErrorBoundary(withSuspense(LazyDataImport));
export const SafeDataExport = withErrorBoundary(withSuspense(LazyDataExport));
export const SafeProjects = withErrorBoundary(withSuspense(LazyProjects));
export const SafeUserManagement = withErrorBoundary(withSuspense(LazyUserManagement));
export const SafeInvoices = withErrorBoundary(withSuspense(LazyInvoices));
export const SafeHubSpotIntegration = withErrorBoundary(withSuspense(LazyHubSpotIntegration));
export const SafeDocs = withErrorBoundary(Docs); // Keep immediate for help
export const SafeAutomation = withErrorBoundary(SimplifiedAutomation); // Using simplified version
export const SafeCommunicationHub = withErrorBoundary(CommunicationHub); // Keep immediate for now
export const SafeFinancialDashboard = withErrorBoundary(FinancialDashboard); // Keep immediate for now
export const SafeSecurityDashboard = withErrorBoundary(SecurityDashboard); // Keep immediate for now
export const SafeIntegrationSettings = withErrorBoundary(IntegrationSettings); // Keep immediate for now